module.exports = __webpack_public_path__ + "img/洛阳宏兴新能化工有限公司.9e079c63.jpg";